import { render, staticRenderFns } from "./g-search-item.vue?vue&type=template&id=50600d7e&scoped=true&"
import script from "./g-search-item.vue?vue&type=script&lang=js&"
export * from "./g-search-item.vue?vue&type=script&lang=js&"
import style0 from "./g-search-item.vue?vue&type=style&index=0&id=50600d7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50600d7e",
  null
  
)

export default component.exports